// @noflow
import jquery from "jquery";

window.jQuery = jquery;
window.jquery = jquery;
window.$ = jquery;

// require("jquery-imagemapster");
require("animate.css");
